var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-card',{staticClass:"tw-text-center"},[_c('div',{staticClass:"tw-py-8"},[_c('span',{staticClass:"tw-m-0 text-info text-4xl"},[_vm._v("Bienvenida, "),_c('b',[_vm._v(_vm._s(_vm.sessionName))])]),_vm._v(" "),_c('span',{staticClass:"text-secondary tw-block text-2xl"},[_vm._v(_vm._s(_vm.subTitle))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17898515","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/shared/components/business/GreetingsHeader.vue
// module id = 1772
// module chunks = 41 61